var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossedSwords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFB961",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7066 45.8398L18.9331 45.0664L18.1597 44.293H15.0662L14.2928 45.0665C13.0134 46.3459 13.0134 48.4274 14.2928 49.7069C15.5722 50.9863 17.6537 50.9863 18.9332 49.7069L19.7066 48.9335L19.7066 45.8398Z",
    fill: "#FED843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9334 49.7068L19.7068 48.9334V45.8398L18.9334 45.0664L14.293 49.7068C15.5724 50.9863 17.654 50.9863 18.9334 49.7068Z",
    fill: "#FABE2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8004 42.747L22.027 41.9735L21.2536 41.2002H18.16L15.0664 44.2938L17.3866 46.614L19.7068 48.9342L22.8004 45.8405V42.747Z",
    fill: "#47568C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8002 45.8406V42.7471L22.0269 41.9736L17.3865 46.614L19.7067 48.9343L22.8002 45.8406Z",
    fill: "#29376D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6668 20.6138V14.4266C50.6668 14.1245 50.5445 13.8511 50.3466 13.6532C50.1487 13.4554 49.8753 13.333 49.5732 13.333H43.386C43.096 13.333 42.8181 13.4478 42.6126 13.6533L20.4802 35.7856L24.3472 39.6526L28.2142 43.5196L50.3466 21.3872C50.552 21.1817 50.6668 20.9039 50.6668 20.6138Z",
    fill: "#E2D9FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3467 21.3874C50.5521 21.182 50.6669 20.904 50.6669 20.6139V14.4267C50.6669 14.1247 50.5446 13.8512 50.3467 13.6533L24.3474 39.6527L28.2144 43.5197L50.3467 21.3874Z",
    fill: "#C7C1DC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3471 39.6531L22.0269 37.333L18.1599 41.2L20.4801 43.5201L22.8003 45.8403L26.6672 41.9733L24.3471 39.6531Z",
    fill: "#61729B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4763 43.5166L24.3427 39.6502L26.6626 41.97L22.7962 45.8364L20.4763 43.5166Z",
    fill: "#47568C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7613 43.5204L25.1209 38.88L20.4804 34.2396C20.0529 33.8121 19.3611 33.8121 18.9337 34.2396C18.5062 34.6671 18.5062 35.3589 18.9337 35.7864L23.5741 40.4268L28.2145 45.0672C28.642 45.4947 29.3338 45.4947 29.7613 45.0672C30.1887 44.6397 30.1888 43.9479 29.7613 43.5204Z",
    fill: "#FED843"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7607 45.0661C30.1882 44.6386 30.1882 43.9468 29.7607 43.5193L25.1203 38.8789L23.5735 40.4257L28.2139 45.0661C28.6413 45.4935 29.3332 45.4935 29.7607 45.0661Z",
    fill: "#FABE2C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8401 44.293L45.0666 45.0664L44.2932 45.8398V48.9334L45.0666 49.7068C46.346 50.9862 48.4276 50.9862 49.7071 49.7068C50.9864 48.4274 50.9864 46.3459 49.7071 45.0664L48.9336 44.293H45.8401Z",
    fill: "#FED843"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7071 45.0664L48.9336 44.293H45.8401L45.0667 45.0664L49.7071 49.7068C50.9865 48.4273 50.9865 46.3458 49.7071 45.0664Z",
    fill: "#FABE2C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7467 41.2002L41.9733 41.9735L41.2 42.747V45.8405L44.2935 48.9342L46.6137 46.614L48.9339 44.2938L45.8403 41.2002H42.7467Z",
    fill: "#47568C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8399 41.2002H42.7463L41.9729 41.9735L46.6133 46.614L48.9335 44.2938L45.8399 41.2002Z",
    fill: "#29376D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.614 13.333H14.4269C14.1248 13.333 13.8514 13.4554 13.6535 13.6533C13.4556 13.8512 13.3333 14.1245 13.3333 14.4266V20.6138C13.3333 20.9038 13.448 21.1817 13.6535 21.3872L35.7859 43.5196L39.6529 39.6526L43.5198 35.7856L21.3875 13.6533C21.182 13.4478 20.9041 13.333 20.614 13.333Z",
    fill: "#F2F2FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3875 13.6533C21.1821 13.4478 20.9042 13.333 20.6141 13.333H14.4269C14.1248 13.333 13.8515 13.4554 13.6536 13.6533L39.6529 39.6526L43.5199 35.7856L21.3875 13.6533Z",
    fill: "#E2D9FB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6531 39.6531L37.333 41.9733L41.2 45.8403L43.5201 43.5201L45.8403 41.2L41.9733 37.333L39.6531 39.6531Z",
    fill: "#61729B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6475 39.6523L41.9673 37.3325L45.8337 41.1989L43.5139 43.5187L39.6475 39.6523Z",
    fill: "#47568C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5197 34.2396L38.8793 38.88L34.2388 43.5204C33.8113 43.9479 33.8113 44.6397 34.2388 45.0672C34.6664 45.4947 35.3582 45.4947 35.7856 45.0672L40.426 40.4268L45.0665 35.7864C45.494 35.3588 45.494 34.667 45.0665 34.2396C44.639 33.8121 43.9472 33.8121 43.5197 34.2396Z",
    fill: "#FED843"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0668 34.2396C44.6393 33.8121 43.9475 33.8121 43.5201 34.2396L38.8796 38.88L40.4264 40.4268L45.0668 35.7864C45.4943 35.3589 45.4943 34.6671 45.0668 34.2396Z",
    fill: "#FABE2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossedSwords);
export default __webpack_public_path__ + "static/media/crossed-swords.816d108b35df199badc07d398309574b.svg";
export { ForwardRef as ReactComponent };